import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const muiStylesOveride = makeStyles((theme: Theme) =>
  createStyles({
    select: {
      // Icon
      "& .MuiSelect-icon": {
        margin: '0 0 0 8px',
        right: '27px',
        width: '13px',
        top: '50%',
        transform: 'translateY(-50%)',
        ['@media (max-width:1536px)']: {
          right: '28px',
          width: '12px',
        },
        ['@media (max-width:1280px)']: {
          right: '24px',
          width: '11px',
        },
        ['@media (max-width:1024px)']: {
          right: '17px',
        }
      }
    },
    dropdown: {
      // Dropdown list container
      maxHeight: '400px',
      minWidth: '100% !important',
      borderRadius: '0',
      "& ul": {
        border: '1px solid #c4c5ca',
        boxSizing: 'border-box',
        display: 'inline-flex',
        flexWrap: 'wrap',
        padding: '15px !important',
        minWidth: '100%',
        ['@media (max-width:1280px)']: {
          padding: '13px !important',
        },
        ['@media (max-width:375px)']: {
          padding:'8px !important',
        }
      },
    },
    menuItem: {
      // Dropdown list items
      "&.MuiListItem-button": {
        alignItems: 'center',
        alignSelf: 'flex-start',
        border: '1px solid #ebebed',
        borderRadius: '16px',
        cursor: 'pointer',
        display: 'inline-flex',
        fontFamily: '"Open Sans Regular", arial',
        fontSize: '17px',
        height: '36px',
        padding: '0px 16px',
        margin: '8px',
        minHeight: 'auto',
        width: 'auto',
        whiteSpace: 'nowrap',
        transitionDuration: '0.175s',
        transitionTimingFunction: 'ease-in-out',
        transitionProperty: 'background-color',
        ['@media (max-width:1536px)']: {
          fontSize: '16px',
          height: '34px',
          padding: '0 15px',
        },
        ['@media (max-width:1280px)']: {
          fontSize: '15px',
          height: '32px',
          padding:' 0 14px',
        },
        // x svg
        "& svg": {
          display: 'none',
          height: '13px',
          width: '13px',
          margin: '0 0 0 8px',
          ['@media (max-width:1536px)']: {
            height: '12px',
            width: '12px',
          },
          ['@media (max-width:1280px)']: {
            height: '11px',
            width: '11px',
          }
        },
        // Active item
        "&.Mui-selected": {
          backgroundColor: '#282d3d',
          color: '#ffffff',
          "& svg": {
            display: 'block',
          }
        }
      }
    }
  }),
);

export default muiStylesOveride
